<template>
  <button
    class="c-button"
    :class="[{ 'c-button--active': active }, `c-button--${mode}`]"
    v-on:click="$emit('click', true)"
  >
    <slot></slot>
  </button>
</template>
<script>
export default {
  props: {
    active: {
      type: Boolean,
      default: () => false,
    },
    mode: {
      type: String,
      default: () => "black",
    },
  },
};
</script>
<style lang="scss">
@import "../_variables.scss";
.c-button {
  max-width: 536px;
  min-width: 248px;
  padding: 0.75rem 2rem;
  font-weight: 100;
  text-align: center;
  font-size: 1.25rem;
  color: $white;
  background: $black;
  cursor: pointer;
  transition: background 0.25s;
  border: 0;
  display: block;
  width: 100%;
  font-family: "Land Rover Wide";
  font-size: 1rem;
  &:hover {
    background: #fff;
    position: relative;
    color: $darkGray;
    &::before {
      content: " ";
      display: block;
      border: 1px solid $black;
      position: absolute;
      top: 0rem;
      left: 0rem;
      right: 0rem;
      bottom: 0rem;
    }
  }
  &--active,
  &--active:hover {
    background-color: $green;
    color: $ultraBrightGray;
  }
  &--white {
    background-color: $white;
    color: $black;
  }
}
</style>
